import React from 'react';

const Scroll = (props) => {
    return (
        <div style={{ overflowY: 'scroll', border: '5px solid black', height: '790px' }}>
            {props.children}
        </div>
    );
}

export default Scroll;



// WEBPACK FOOTER //
// ./src/components/Scroll.js